import Vue from "vue";
import Vuetify from "vuetify/lib";
import Uikit from "@foxone/uikit";
import en from "vuetify/es5/locale/en";
import zh from "vuetify/es5/locale/zh-Hans";
import ja from "vuetify/es5/locale/ja";
import en_uikit from "@foxone/uikit/src/locales/en";
import ja_uikit from "@foxone/uikit/src/locales/ja";
import zh_uikit from "@foxone/uikit/src/locales/zh-Hans";

Vue.use(Vuetify);
Vue.use(Uikit);

const icons = {
  iconfont: "mdiSvg",
  values: {
    iconEye: {
      component: "icon-eye"
    },
    iconEyeOff: {
      component: "icon-eye-off"
    },
    iconArrowRight: {
      component: "icon-arrow-right"
    },
    iconWyre: {
      component: "icon-wyre"
    },
    iconAddress: {
      component: "icon-address"
    },
    iconContact: {
      component: "icon-contact"
    },
    iconWallet: {
      component: "icon-wallet"
    },
    iconDiscover: {
      component: "icon-discover"
    },
    iconMine: {
      component: "icon-mine"
    },
    iconSettings: {
      component: "icon-settings"
    },
    iconFeedback: {
      component: "icon-feedback"
    },
    iconHelps: {
      component: "icon-helps"
    },
    iconMixin: {
      component: "icon-mixin"
    },
    iconLoan: {
      component: "icon-loan"
    },
    iconSwitch: {
      component: "icon-switch"
    },
    iconSwitchVertical: {
      component: "icon-switch-vertical"
    },
    iconAddOutline: {
      component: "icon-add-outline"
    },
    iconOtc: {
      component: "icon-otc"
    },
    iconRegularInvest: {
      component: "icon-regular-invest"
    },
    iconGlobal: {
      component: "icon-global"
    },
    iconHfox: {
      component: "icon-hfox"
    },
    iconDefi: {
      component: "icon-defi"
    },
    iconOrder: {
      component: "icon-order"
    },
    iconPlus: {
      component: "icon-plus"
    },
    iconInvite: {
      component: "icon-invite"
    },
    iconCheck: {
      component: "icon-check"
    },
    iconTools: {
      component: "icon-tools"
    },
    iconTrade: {
      component: "icon-trade"
    },
    iconDefiShade: {
      component: "icon-defi-shade"
    },
    iconRefresh: {
      component: "icon-refresh"
    }
  }
} as const;

export default function(store) {
  const isDark = store.state.app?.settings.dark || false;

  const a = new Vuetify({
    icons,
    theme: {
      dark: isDark,
      options: {
        customProperties: true
      },
      themes: {
        light: {
          accent: "#169CFE",
          primary: "#076AFF",
          secondary: "#003d69",
          grayscale_1: "#000000",
          grayscale_2: "#333333",
          grayscale_3: "#666666",
          grayscale_4: "#CCCCCC",
          grayscale_5: "#EBEBEB",
          grayscale_6: "#F5F5F5",
          background: "#FFFFFF"
        },
        dark: {
          accent: "#169CFE",
          primary: "#3988FF",
          secondary: "#81BEEA",
          grayscale_1: "#FFFFFF",
          grayscale_2: "#D2D3D3",
          grayscale_3: "#9B9C9D",
          grayscale_4: "#636466",
          grayscale_5: "#3C3C3C",
          grayscale_6: "#191919",
          background: "#000000"
        }
      }
    },
    lang: {
      locales: {
        zh: {
          ...zh,
          ...zh_uikit
        },
        en: {
          ...en,
          ...en_uikit
        },
        ja: {
          ...ja,
          ...ja_uikit
        }
      }
    }
  });

  return a;
}
